import type { AddressDto, CountryDto } from '@/castapi';
import {
  addressLine as addressLineFn,
  getAddress as getAddressFn,
  isAddressValid as isAddressValidFn,
} from '@/castapi/helpers';

export const addressLine = (address: undefined | Partial<AddressDto>, countries: CountryDto[]): string => {
  return address ? addressLineFn(address, countries) : '';
};

export const isAddressValid = (address?: AddressDto): boolean => {
  return isAddressValidFn(address);
};

export const getAddress = (address?: AddressDto): undefined | Partial<AddressDto> => {
  return getAddressFn(address);
};
